export default "__VITE_ASSET__2MrOh02Z__"